export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_MODULO_MENU_ID':
      return { ...state, idModulo: action.idModulo };
    case 'ADD_MENU_ID':
      return { ...state, idMenu: action.idMenu };
    default:
      return state;
  }
};
